"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var isDev = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
var _default = exports["default"] = isDev;